module.exports = __webpack_public_path__ + "res/img_info_b.70df2352e33382e9d18d071406bf0a2e.png";